import theme from './theme'
import { green } from '@material-ui/core/colors'

export const baseStyle = {
  root: {
    flexGrow: 1,
  },
  // title: {
  //   flexGrow: 1,
  // },
  title: {
    marginLeft: theme.spacing(2),
    color: theme.palette.white.main,
    flex: 1,
  },
  wrapper: {
    paddingRight: 30,
    paddingLeft: 30,
  },
  form: {
    fontSize: '100%',
  },
  h1: {
    marginTop: '40px',
    marginBottom: '20px',
    fontSize: '200%',
    fontWeight: 400,
  },
  h2: {
    marginTop: '40px',
    marginBottom: '20px',
    fontSize: '200%',
    fontWeight: 400,
  },
  table: {
    minWidth: 300,
  },

  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },

  green: {
    color: '#fff',
    backgroundColor: green[500],
    fontSize: '90%',
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    fontSize: '80%',
  },

  avatar: {
    width: '10%'
  },
  note: {
    width: '90%',
    // backgroundColor: '#eee'
  },
  btn: {
    fontSize: '60%',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginTop: 20,
    marginRight: 15,
  },
  appBar: {
    position: 'relative',
  },
  ul: {
    marginTop: 20,
    marginBottom: 20
  },
  li: {
    borderBottom: '1px solid #ccc'
  },

  menuButton: {
    marginRight: theme.spacing(2),
  },

  select: {
    minWidth: 150,
    marginRight: 20,
  }
}